import React from 'react'
import axios from 'axios'
import { useTranslation } from 'react-i18next';

const useFetchGuidesByRegion = () => {
    const [guides, setGuides] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(false);
    const { i18n } = useTranslation();

    const fetchGuides = React.useCallback(async () => {
        setIsLoading(true)
        const { REACT_APP_BASE_URL } = process.env
        const token = localStorage.getItem('token');

        try {
            const { data } = await axios.get(
                `${REACT_APP_BASE_URL}/index.php?r=api/destinationguides/byregions`,
                {
                    headers: {
                        'x-authorization-token': token
                    },
                    params: {
                        lng: i18n.language
                    }
                }
            ) || {}

            setIsLoading(false)
            if (data.length) {
                setGuides(data)
            }
        } catch (err) {
            console.error('Error fetching guides by region: ', err)
            setIsLoading(false)
        }
    }, [])

    React.useEffect(() => {
        fetchGuides()
    }, [fetchGuides])

    return {
        guides,
        isLoading,
    }
}

export default useFetchGuidesByRegion
